import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=2a49a100&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
import style0 from "./event.css?vue&type=style&index=0&id=2a49a100&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49a100",
  null
  
)

export default component.exports